import OadpTab from './oadp-tab';
export default OadpTab;
